import script from "./myTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./myTabs.vue?vue&type=script&lang=ts&setup=true"

import "./myTabs.vue?vue&type=style&index=0&id=5f39194e&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f39194e"]])

export default __exports__